<template>
    <span v-if="props.value === 'p'">Petición</span>
    <span v-if="props.value === 'q'">Queja</span>
    <span v-if="props.value === 'r'">Reclamo</span>
    <span v-if="props.value === 's'">Sugerencia</span>
</template>

<script setup>
import { defineProps } from 'vue';

const props = defineProps({
    value: String
});
</script>
